import { Grid } from "@mui/material";
import { DetailsFormSectionProps } from "models/propTypes/wintFormPropsTypes";
import GroupSectionInline from "../formSections/groupSectionInline";
import GroupSection from "../formSections/groupSection";

const DetailsFormSection: React.FC<React.PropsWithChildren<DetailsFormSectionProps>> = (props) =>
  props.readonly ? (
    <GroupSectionInline {...props} label={props.header}>
      <Grid container direction="row">
        {props.children}
      </Grid>
    </GroupSectionInline>
  ) : (
    <GroupSection {...props} />
  );

export default DetailsFormSection;
